import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FacilityType } from '../../types/facilityTypes';

export interface Facility {
  id: string;
  type: FacilityType;
  x: number;
  y: number;
}

export interface FacilitiesState {
  facilities: Facility[];
}

const initialState: FacilitiesState = {
  facilities: [],
};

const facilitiesSlice = createSlice({
  name: 'facilities',
  initialState,
  reducers: {
    placeFacility: (state, action: PayloadAction<{ x: number; y: number; type: FacilityType }>) => {
      const { x, y, type } = action.payload;
      const newFacility: Facility = {
        id: Date.now().toString(),
        type,
        x,
        y,
      };
      state.facilities.push(newFacility);
    },
  },
});

export const { placeFacility } = facilitiesSlice.actions;
export default facilitiesSlice.reducer;